import React, { FC, Fragment } from 'react';
import { Icon } from 'enova-frontend-components';
import { useTranslation } from 'react-i18next';

import { StyledChip } from '../components';
import useBuildingFilter from '../../../../../../hooks/useBuildingFilter';

import { FilterDrawer } from './filterDrawer';

interface Props {
  filterCount: number;
}

export const FilterChip: FC<Props> = ({ filterCount }) => {
  const { t } = useTranslation();
  const { setFilterVisible, filterVisible } = useBuildingFilter();

  const filterCaption = `${t(filterVisible ? 'filter.hide' : 'filter.show')}  ${
    filterCount > 0 ? `(${filterCount})` : ''
  }`;

  return (
    <Fragment>
      <StyledChip
        aria-label={filterCaption}
        variant={filterVisible || filterCount > 0 ? 'primary' : 'secondary'}
        onClick={() => setFilterVisible(!filterVisible)}
        label={
          <Fragment>
            {filterCaption}
            <Icon name="filter" fontSize="small" />
          </Fragment>
        }
      />
      <FilterDrawer />
    </Fragment>
  );
};
